<template>
  <div class="page-container">
    <div class="print-hidden">
      <template v-if="aHeaderCollectivite">
        <HeaderCollectivite />
      </template>
      <template v-else>
        <Header />

      </template>
    </div>

    <main id="contenu" class="background--main" role="main">
      <MessageFlash />

      <router-view />
    </main>

    <Footer class="print-hidden" />
    <p v-if="!estEnvDeProduction">Version : {{ appVersion }}</p>
  </div>
</template>

<script lang="ts" setup>
  import { useHead } from '@unhead/vue';
  import axios from 'redaxios';
  import { computed, onMounted, ref } from 'vue';
  import { NavigationGuardNext, RouteLocationNormalized, useRoute } from 'vue-router';
  import MessageFlash from '@/components/custom/MessageFlash.vue';
  import Footer from '@/components/dsfr/Footer.vue';
  import Header from '@/components/dsfr/Header.vue';
  import HeaderCollectivite from '@/components/dsfr/HeaderCollectivite.vue';
  import router from '@/router';
  import useHeadProperties from '@/shell/useHeadProperties';
  import { useNavigationStore } from '@/store/navigationStore';

  const estEnvDeProduction = import.meta.env.VITE_ENV === 'production';

  // eslint-disable-next-line no-undef
  const appVersion = __APP_VERSION__;
  const latestVersion = ref(appVersion);

  const route = useRoute();
  const aHeaderCollectivite = computed(() => {
    return route.meta?.headerCollectivite;
  });

  router.beforeEach((to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
    const { title } = to.meta;

    if (title) {
      useHead({ ...useHeadProperties, title: `${title as string}` });
    }

    const navigationStore = useNavigationStore();
    if (from.fullPath && from.name) {
      navigationStore.addRoute(from.fullPath, from.name as string, from.query);
    }

    next();
  });

  const checkVersion = async () => {
    if (import.meta.env.DEV) return;
    try {
      const response = await axios.get('/version.json', {
        headers: {
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          Pragma: 'no-cache',
          Expires: '0',
        },
      });
      latestVersion.value = response.data.version;

      if (latestVersion.value !== appVersion) {
        window.location.reload();
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Erreur lors de la récupération de la version :', error);
    }
  };

  onMounted(() => {
    checkVersion();
  });
</script>

<style scoped>
  .page-container {
    display: grid;
    grid-template-rows: auto 1fr auto;
    min-height: 100vh;
  }
</style>
